export enum AdjustedMixDesignQtyType {
  Nominal = 'Nominal',
  Cumulative = 'Cumulative',
  Percentage = 'Percentage',
  SecondWater = 'SecondWater',
  Ice = 'Ice',
  IcePerVolume = 'IcePerVolume',
}
